import { render, staticRenderFns } from "./Countries.vue?vue&type=template&id=a20a875c&"
import script from "./Countries.ts?vue&type=script&lang=ts&"
export * from "./Countries.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports